import * as React from 'react';
import { Resource } from 'react-admin';
import ReceiptsCounter from './view';

const ReceiptsCounterPage: React.ComponentProps<typeof Resource> = {
    name: 'ReceiptsCounter',
    list: ReceiptsCounter
};

export default ReceiptsCounterPage;
